var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGentericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_6789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8595 2.73333H11.9921V2.2H16.2587V6.46667H15.7254V3.61723V3.13733L15.3846 3.4752L10.5978 8.22073L10.4791 8.33835L10.5737 8.47604C10.8729 8.91139 11.1183 9.37081 11.3101 9.85446C11.4981 10.3287 11.5921 10.8212 11.5921 11.3333C11.5921 12.5824 11.1601 13.6343 10.2936 14.5011C9.42704 15.3679 8.37556 15.8 7.12704 15.8C5.8785 15.8 4.82641 15.368 3.95878 14.5014C3.0912 13.6349 2.65874 12.5834 2.65874 11.335C2.65874 10.0864 3.09086 9.03437 3.95776 8.16673C4.82459 7.29914 5.87645 6.86667 7.12541 6.86667C7.63776 6.86667 8.12714 6.95985 8.59495 7.14603L8.59502 7.14605C9.0721 7.33571 9.52633 7.58155 9.95786 7.88395L10.0953 7.9803L10.2141 7.86159L15.0009 3.07475L15.3423 2.73333H14.8595ZM4.34177 8.55286L4.34176 8.55288C3.57677 9.31998 3.19207 10.2515 3.19207 11.3361C3.19207 12.4211 3.57784 13.3518 4.34493 14.117L4.34495 14.117C5.11206 14.882 6.04355 15.2667 7.12821 15.2667C8.21319 15.2667 9.14392 14.8809 9.90904 14.1138L9.90906 14.1138C10.674 13.3467 11.0587 12.4152 11.0587 11.3305C11.0587 10.2455 10.673 9.31482 9.90588 8.5497L9.90586 8.54968C9.13876 7.7847 8.20727 7.4 7.12261 7.4C6.03762 7.4 5.1069 7.78577 4.34177 8.55286Z",
    fill: "#189FAA",
    stroke: "#189FAA",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_6789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.95874 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGentericon);
export default __webpack_public_path__ + "static/media/gentericon.d558c87f43eb96e4c5bb824a64354e03.svg";
export { ForwardRef as ReactComponent };